import * as MatStyled from "@mui/material/styles";

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, bg }) => ({
  position: "relative",
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
  marginTop: "75px",
  height: "calc(100vh - 75px)",
  overflow: "hidden",
  overflowY: "scroll",
  scrollBehavior: "smooth",
  backgroundColor: bg === "white" ? "#ffffff" : "#f3f1f2",
  [theme.breakpoints.down("md")]: {
    marginTop: "64px",
    height: "calc(100vh - 64px)",
  },
}));

const Container = (props) => {
  return <Main {...props}>{props.children}</Main>;
};

export default Container;
